import { DateTime } from "luxon";

const formatTimeString = (dateString, timezoneName) => {
  try {
    // Parse the ISO date string and create a DateTime object
    const utcDateTime = DateTime.fromISO(dateString, { zone: "utc" });

    if (!utcDateTime.isValid) {
      console.error("Invalid date string:", dateString);
      return "Invalid Date";
    }

    // Convert to the specified timezone - Luxon automatically handles DST
    const adjustedDateTime = utcDateTime.setZone(timezoneName);

    if (!adjustedDateTime.isValid) {
      console.error("Invalid timezone:", timezoneName);
      return "Invalid Date";
    }

    console.log(
      "Timezone conversion:",
      dateString,
      "->",
      adjustedDateTime.toFormat("h:mm a"),
      "Timezone:",
      timezoneName,
      "Is in DST:",
      adjustedDateTime.isInDST,
      "Offset (hours):",
      adjustedDateTime.offset / 60
    );

    // Format to 12-hour time with AM/PM
    return adjustedDateTime.toFormat("h:mm a");
  } catch (error) {
    console.error("Error in formatTimeString:", error);
    return "Invalid Date";
  }
};

export default formatTimeString;
